import { Flex, Stepper } from '@servicetitan/anvil2';
import { SubmitApplicationDecision } from '@servicetitan/financing-api-client';
import { WorkflowButtonsStore } from '@servicetitan/financing-workflow-shared';
import { DecisionDataStore, Approved, CounterOffer } from '@servicetitan/financing-decision-shared';

export const DecisionResultStep = () => {
    const { decisionData } = DecisionDataStore.useStore();

    return decisionData.decision === SubmitApplicationDecision.Approved ? (
        <Approved isSecondLookApproval={false} />
    ) : decisionData.decision === SubmitApplicationDecision.CounterOffer ? (
        <CounterOffer />
    ) : null;
};

export const DecisionResultButtons = () => {
    const { CancelApplicationButton } = WorkflowButtonsStore.useStore();
    return (
        <Flex justifyContent="space-between">
            <Stepper.PrevButton label="Back" />
            <Flex gap="3" justifyContent="flex-end" grow={1}>
                <CancelApplicationButton>Cancel</CancelApplicationButton>
                <Stepper.NextButton nextLabel="Next" />
            </Flex>
        </Flex>
    );
};
